"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const react_router_dom_1 = require("react-router-dom");
const scheduled_transactions_1 = require("companion-app-components/flux/scheduled-transactions");
const accounts_1 = require("companion-app-components/flux/accounts");
const core_1 = require("companion-app-components/utils/core");
const feature_flags_1 = require("companion-app-components/flux/feature-flags");
const budgetsSelectors_1 = require("companion-app-components/flux/budgets/budgetsSelectors");
const TaskListProgress_1 = __importDefault(require("components/TaskListProgress"));
let globalStateOpen = true;
const SetupStatusBar = (props) => {
    const navigate = (0, react_router_dom_1.useNavigate)();
    const { titleOnTop, classes, selected, onOpenToggle, name } = props;
    const [open, setOpen] = (0, react_1.useState)(globalStateOpen);
    const accountsById = (0, react_redux_1.useSelector)((state) => accounts_1.accountsSelectors.getAccountsById(state));
    const scheduledTransactionsById = (0, react_redux_1.useSelector)((state) => scheduled_transactions_1.scheduledTransactionsSelectors.getScheduledTransactions(state));
    const budgetsById = (0, react_redux_1.useSelector)((state) => (0, budgetsSelectors_1.getBudgets)(state));
    const isScheduledTransactionsLoading = (0, react_redux_1.useSelector)((state) => scheduled_transactions_1.scheduledTransactionsSelectors.getIsLoading(state));
    const useScheduledTransactions = (0, react_redux_1.useSelector)((state) => feature_flags_1.featureFlagsSelectors.getFeatureFlags(state).get('scheduledTransactions'));
    const setupItems = () => {
        const items = [];
        items.push({
            name: 'addAccounts',
            title: 'Add Accounts',
            completed: accountsById.size > 0,
        });
        if (useScheduledTransactions) {
            items.push({
                name: 'connectBills',
                title: 'Connect Your Bills',
                completed: !isScheduledTransactionsLoading && scheduledTransactionsById &&
                    // @ts-expect-error: Property 'isUserVerified' does not exist on type 'ScheduledTransaction'.
                    scheduledTransactionsById.size > 0 && scheduledTransactionsById.filter((x) => x.isUserVerified).size > 0,
            });
        }
        items.push({
            name: 'createBudget',
            title: 'Create a Budget',
            completed: budgetsById && budgetsById.size > 0,
        });
        return items;
    };
    const onClick = (e, itemName) => {
        switch (itemName) {
            case 'addAccounts':
                if (!titleOnTop) {
                    core_1.tracker.track(core_1.tracker.events.dashboardAddAccount);
                }
                else {
                    core_1.tracker.track(core_1.tracker.events.wizardTopMenuAccounts);
                }
                navigate('/getting-started-webfirst?page=addAccounts');
                break;
            case 'connectBills':
                if (!titleOnTop) {
                    core_1.tracker.track(core_1.tracker.events.dashboardBillscout);
                }
                else {
                    core_1.tracker.track(core_1.tracker.events.wizardTopMenuBillscout);
                }
                navigate('/getting-started-webfirst?page=connectBills');
                break;
            case 'createBudget':
                if (!titleOnTop) {
                    core_1.tracker.track(core_1.tracker.events.dashboardAddBudget);
                }
                else {
                    core_1.tracker.track(core_1.tracker.events.wizardTopMenuBudgets);
                }
                navigate('/getting-started-webfirst?page=createBudget');
                break;
            default:
                break;
        }
    };
    return (<TaskListProgress_1.default setupItems={setupItems()} selected={selected} open={open} titleOnTop={titleOnTop} onOpenToggle={titleOnTop ? null : (e, val) => {
            globalStateOpen = val;
            setOpen(val);
            if (onOpenToggle) {
                onOpenToggle(val);
            }
        }} onClick={onClick} classes={classes} name={name}/>);
};
exports.default = SetupStatusBar;
